import React, { useState } from 'react';
import { Button, MenuItem, Popper, Paper, Fade } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '../../../../common/StyledToolTip';
import SearchBox from '../../../../common/SearchBox';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const HolidayGridHeader = ({
  classes,
  gridApi,
  openAddEditHolidayPanel,
  updateQuickFilterText,
  isEditCustomerDialog
}) => {
  const [holidayHeaderMenuAnchor, setHeaderAnchor] = useState(null);

  const openHolidayHeaderMenu = (event) => {
    setHeaderAnchor(event.currentTarget);
  };

  const closeHolidayHeaderMenu = () => {
    setHeaderAnchor(null);
  };

  return (
    <div className={classes.gridHead}>
      <SearchBox onChange={updateQuickFilterText} />
      <ClearAllFilterButton gridApi={gridApi} />
      {isEditCustomerDialog ? (
        <span
          onMouseLeave={closeHolidayHeaderMenu}
          className={`${classes.headerIconStyles} ${classes.iconLayout}`}>
          <div className={classes.actionContainer}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              classes={{ root: classes.actionButton }}
              onMouseOver={openHolidayHeaderMenu}
              data-automationid="AddHoliday">
              + Add Holiday
            </Button>
          </div>
          <Popper
            id="pickupHeaderMoreMenu"
            open={Boolean(holidayHeaderMenuAnchor)}
            anchorEl={holidayHeaderMenuAnchor}
            onClose={closeHolidayHeaderMenu}
            transition
            className={classes.customPopper}
            modifiers={{
              offset: {
                enabled: true,
                offset: '12,0'
              }
            }}
            placement="bottom-end">
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={{ exit: 500 }}>
                <Paper className={classes.mainMenu}>
                  <MenuItem className={classes.menuItem}>
                    <div
                      className={`${classes.headerMenuIconStyles} ${classes.iconLayout} `}
                      onClick={() => openAddEditHolidayPanel(true)}>
                      <span className={classes.iconLabel}>Customer Specific</span>
                      <Tooltip title="In case customer is temporarily closed for few days.">
                        <InfoOutlinedIcon />
                      </Tooltip>
                    </div>
                  </MenuItem>
                  <MenuItem className={classes.menuItem}>
                    <div
                      className={`${classes.headerMenuIconStyles} ${classes.iconLayout} `}
                      onClick={() => openAddEditHolidayPanel(false)}>
                      <span className={classes.iconLabel}>Shared Holiday</span>
                      <Tooltip title="Holidays that can be applied to other customers as well.">
                        <InfoOutlinedIcon />
                      </Tooltip>
                    </div>
                  </MenuItem>
                </Paper>
              </Fade>
            )}
          </Popper>
        </span>
      ) : (
        <div className={classes.actionContainer}>
          <Button
            color="primary"
            variant="contained"
            size="small"
            classes={{ root: classes.actionButton }}
            onClick={openAddEditHolidayPanel}
            data-automationid="AddHoliday">
            + Add Holiday
          </Button>
        </div>
      )}
    </div>
  );
};

export default HolidayGridHeader;
